var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmojiConfusedFaceGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4593",
    "data-name": "Path 4593",
    d: "M60,10.5a10,10,0,1,1,10,10A10,10,0,0,1,60,10.5Zm14.547,2.477a.626.626,0,0,0-.344-1.2l-8.75,2.5a.626.626,0,1,0,.344,1.2Zm-7.656-5.6a1.25,1.25,0,1,0,1.25,1.25A1.249,1.249,0,0,0,66.891,7.375Zm6.25,2.5a1.25,1.25,0,1,0-1.25-1.25A1.251,1.251,0,0,0,73.141,9.875Z",
    transform: "translate(-60 -0.5)",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiConfusedFaceGrey);
export default __webpack_public_path__ + "static/media/emoji-confused-face-grey.1ccd7944ba8c5aad2e72b4340264c6cd.svg";
export { ForwardRef as ReactComponent };